
const Config = {
    debugMode: false,
    autoUpdateEnabled: false,
    url: 'https://api-nebula.spl-token.com/',
    urlDebug: 'http://127.0.0.1:3011/',
    version: '2.934',
    tokenNsaAddress: '4CuBdvKbwy1wo8o9sDs7mUQZTL1weKitpBA6X2D5a1nX',
    tokenNsanAddress: '6J8zQqphXpyM19vKKnAdWn9VWgyEHwuW9q1xzm3wY91W',
    marketIdMsolUsdt: '9Lyhks5bQQxb9EyyX55NtgKQzpM4WK7JCmeaWuQ5MoXD',
    marketIdSolUsdt: '8BnEgHoWFysVcuFFX7QztDmzuH8r5ZFvyP3sYwn1XTh6',
    marketIdNsaUsdt: '9Hfa9aARXtSYKqVxdpvVWZB3gGW4sHffasm8QTptSoZn',
    accountPubkey: '5RtCVaju5kRB9UghFPLPCRuMGpnEG2fvY74s6YxNmdmi',
    mainnetLeoRPC: 'https://solana.leorpc.com/?api_key=FREE',
    gitbookRiskURL: 'https://nebula-stars-anthill.gitbook.io/white-paper-en/policies/the-risks',
};

export default Config;